let state = {

}

let mutations = {

}

let actions = {

}

let moduleB = {
    namespaced: true,
    state,
    mutations,
    actions
}

export {
    moduleB
}


// WEBPACK FOOTER //
// ./src/store/moduleB.js